module.exports = __webpack_public_path__ + "static/media/temp_27.36c340ce.jpg";